import { type FC } from 'react';
import Print24 from './Print24.tsx';

type PrintProps = {
    variation: '24';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Print24,
};

const Print: FC<PrintProps> = ({ variation, ...props }) => {
    const variationKey = `Print${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        return null;
    }

    return <Icon {...props} />;
};

export default Print;
